import React from 'react';
import {ConfigApi, MultistoreLayoutType, PlaceApi} from "../../services/Api/types";
import {useTranslation, withTranslation} from "react-i18next";
import {ReactComponent as CutleryIco} from "../../../images/icons/cutlery.svg";
import AppConfig from "../../services/AppConfig";
import classNames from "classnames";
import StoreUtils from "../../services/Store/StoreUtils";
import {RootState} from "../../../reducers";
import {connect} from "react-redux";
import {getSession} from "../../services/Session/reducer";

interface OwnProps {
    config: ConfigApi | undefined;
    places?: PlaceApi[];
    onButtonClick?: () => void;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const Hero = ({config, places, onButtonClick, session}: Props) => {
    const {t} = useTranslation();

    if (!config) return <></>;

    const cover = config.layout.cover_large ?? "/images/test/cover.jpg";
    const isReadonly = StoreUtils.isOrderingReadonly(config);
    const isMultistore = StoreUtils.isMultistore(config);
    const isHomepageMenu = StoreUtils.isHomepageMenu(config);
    const isQrCodeContext = StoreUtils.isQrcodeContext(session);
    const layout = StoreUtils.getMultistoreLayoutType(config);

    if (AppConfig.isNativeMobile() || AppConfig.isWidget()) return <></>;

    if (isQrCodeContext && isMultistore && layout === MultistoreLayoutType.BRAND_LIST) return <></>;

    if (isQrCodeContext && !isMultistore) return <></>;

    const buildHeroBackground = (image?: string) => {
        const gradient = AppConfig.isDarkMode() ?
            ` linear-gradient(180deg, rgba(31, 41, 58, 0.25) 0%, #1F293A 45%)`
            : `linear-gradient(180deg, rgba(241, 245, 249, 0.25) 0%, #F1F5F9 45%)`;
        return image ? `${gradient}, url("${image}")` : gradient;
    };

    const shouldDrawButtonsSection = () => {
        if (isMultistore) {
            return places && places.length > 0;
        }

        return !isHomepageMenu;
    }

    return (
        <div className="hero">
            <div
                className={classNames('hero-bg', {
                    'hero-bg-image': !!cover
                })}
                style={{backgroundImage: buildHeroBackground(cover)}}
            />
            <div className="hero-content">
                <div className="big-image-container" style={{backgroundImage: `url("${cover}")`}}/>
                {config.description && (
                    <p className="mb-0 description">{config.description}</p>
                )}
                {shouldDrawButtonsSection() && (
                    <div className="d-grid gap-2 d-md-block align-self-center buttons-container">
                        <button className="btn btn-lg btn-primary check-offer-btn" onClick={onButtonClick}>
                            <CutleryIco className="me-2"/>
                            {isReadonly ? t("modules.hero.action.check_our_offer.title") : t("modules.hero.action.check_and_order.title")}
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session)
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(Hero));